import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactComponent } from './components/contact/contact.component';
import { CreditCardComponent } from './components/creditcard/creditcard.component';
import { FaqComponent } from './components/faq/faq.component';
import { HowTosComponent } from './components/howtos/howtos.component';
import { PrivacyPolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { RegisterComponent } from './components/register/register.component';
import { SecurityPolicyComponent } from './components/securitypolicy/securitypolicy.component';
import { TermsAndConditionsComponent } from './components/termsandconditions/termsandconditions.component';
import { WebAccessibilityComponent } from './components/webaccessibility/webaccessibility.component';
import { CreditCardSuccessComponent } from './components/creditcard/creditcard-success/creditcard-success.component';
import { CreditCardCancelComponent } from './components/creditcard/creditcard-cancel/creditcard-cancel.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutModule } from '../layout/base-layout.module';
import { CommonLibraryModule, MaskDataPipe, MaterialLibraryModule } from 'epay-library';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { NcpFAQComponent } from './components/faq/ncp-faq/ncp-faq.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    ContactComponent,
    CreditCardComponent,
    FaqComponent,
    HowTosComponent,
    PrivacyPolicyComponent,
    RegisterComponent,
    SecurityPolicyComponent,
    TermsAndConditionsComponent,
    WebAccessibilityComponent,
    CreditCardSuccessComponent,
    CreditCardCancelComponent,
    NcpFAQComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BaseLayoutModule,
    CommonLibraryModule,
    MatExpansionModule,
    MatCardModule,
    MaterialLibraryModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    ContactComponent,
    CreditCardComponent,
    FaqComponent,
    HowTosComponent,
    PrivacyPolicyComponent,
    RegisterComponent,
    SecurityPolicyComponent,
    TermsAndConditionsComponent,
    WebAccessibilityComponent,
    CreditCardSuccessComponent,
    CreditCardCancelComponent,
  ],
  providers: [MaskDataPipe],
})
export class CommonEpayModule {}
